module Easypass {
    export enum IFluiditeTauxOccupationValues {
        NA = 0,
        Eleve = 1,
        Moyen = 2,
        Faible = 3
    }
}
